import playerCard from "../assets/player_card.png";
import clubCard from "../assets/club_card.png";
import crewCard from "../assets/crew_card.png";
import venueCard from "../assets/venue_card.png";
import secureLocalStorage from "react-secure-storage";
import profile1 from "../assets/profile1.jpg";
import profile2 from "../assets/profile2.jpg";
import profile3 from "../assets/profile3.jpg";
import profile4 from "../assets/profile4.webp";
import profile5 from "../assets/profile5.webp";
import gameIcon from "../assets/game.png";
import notepad from "../assets/notepad.png";
import partner from "../assets/partners.png";
import badminton from "../assets/badminton.png";
import Cookies from "js-cookie";
export const playercards = [
  {
    id: 1,
    title: "Sport/Game Cards",
    description: "See who's Playing nearby",
    image: playerCard,
    badge: 487,
    route: "/cards/sport",
  },
  {
    id: 2,
    title: "Sport Entity Cards",
    description: "Sport Entity led activities nearby",
    image: clubCard,
    route: "/cards/club",
  },
  {
    id: 3,
    title: "Crew Cards",
    description: "Crew led activities nearby",
    image: crewCard,
    route: "/cards/crew",
  },
  {
    id: 4,
    title: "Venue Cards",
    description: "Venue led activities nearby",
    image: venueCard,
    route: "/cards/venue",
  },
];

export const playerFilter = ["Beginner", "Intermediate", "Advanced", "Any"];

export const ageOptions = [
  "U10",
  "U12",
  "U14",
  "U16",
  "U18",
  "Adult",
  "Senior",
  "All Ages",
];

export const genderOptions = [
  { id: "Male", name: "♂️ Male" },
  { id: "Female", name: "♀️ Female" },
  { id: "Mixed", name: "⚧️ Mixed" },
  { id: "All Genders", name: "🌈 All Genders" },
];
export const EVENT_GENDERS = [
  { id: "Male", name: "♂️  Male" },
  { id: "Female", name: "♀️  Female" },
  { id: "Any(All Genders)", name: "⚧️  Any(All Genders)" },
  { id: "Non-binary/other", name: "🏳️‍⚧️  Non-binary/other" },
  { id: "Prefer not to say", name: "🔒  Prefer not to say" },
];

export const gamesSportOptions = [
  "American Football",
  "Archery",
  "Athletics (Track & Field)",
  "Australian Football",
  "Auto Racing",
  "Badminton",
  "Baseball",
  "Basketball",
  "Billiards / Pool",
  "Bowling / Tenpin",
  "Bowls",
  "Boxing",
  "Carrom Board",
  "Chess",
  "Cricket",
  "CrossFit / Functional Training",
  "Curling",
  "Cycling",
  "Dance Fitness / Zumba",
  "Darts",
  "Dodgeball",
  "Dragon Boating",
  "Equestrian",
  "Esports",
  "Fencing",
  "Fishing (Sport)",
  "Football / Soccer",
  "Futsal",
  "Golf",
  "Fitness/Gym",
  "Gymnastics",
  "Handball",
  "Hockey (Field)",
  "Ice Hockey",
  "Judo",
  "Kabaddi",
  "Karting",
  "Kayaking / Canoeing",
  "Lacrosse",
  "Martial Arts (Karate / Taekwondo / MMA)",
  "Motocross",
  "Motorcycle Racing",
  "Motorsport (General)",
  "Mountain Biking",
  "Netball",
  "Orienteering",
  "Padel",
  "Pickleball",
  "Pilates",
  "Polo",
  "Rally",
  "Rowing",
  "Rugby League",
  "Rugby Union",
  "Sailing",
  "Skateboarding",
  "Skating (Roller / Ice)",
  "Skiing",
  "Snow Games",
  "Snowboarding",
  "Softball",
  "Squash",
  "Surfing",
  "Swimming",
  "Table Tennis",
  "Tennis",
  "Triathlon",
  "Ultimate Frisbee",
  "Volleyball",
  "Water Polo",
  "Wrestling",
  "Yoga",
  "Others",
];

export const dropdownItems = ["Player", "Club", "Crew", "Venue"];

export const userType = [
  {
    name: "🏃‍♂️ Player",
    id: 2,
  },
  {
    name: "👥 Sports Entity",
    disable: false,
    id: 3,
  },
  // {
  //   name: '📦 Crew',
  //   id: 4
  // },
  {
    name: "🏟️ Venue",
    disable: false,
    id: 5,
  },
];

const appMode = String(process.env.REACT_APP_MODE || "").trim().toLowerCase();
export const isProductionAppEnvironment = appMode
  ? appMode === "production" || appMode === "prod"
  : process.env.NODE_ENV === "production";

export const authUserType = isProductionAppEnvironment
  ? userType.filter((item) => item.id !== 2)
  : userType;

export const FILTER_USER_TYPES = [
  {
    key: "player",
    displayName: "Player",
    userType: 2,
  },
  {
   key: "crew",
    displayName: "Crew",
    userType: 4,
  },
  {
   key: "venue",
    displayName: "Venue",
    userType: 5,
  }

];

export const FILTER_CLUB_TYPES = [
  {
    name: "Club",
    id: 1,
  },
  {
    name: "Academy",
    id: 2,
  },
  {
    name: "Corporate Sports Group",
    id: 3,
  },
  {
    name: "Tournament Organiser",
    id: 4,
  },
  {
    name: "Professional Body / Association",
    id: 5,
  },
  {
    name: "Clinic / Recovery Centre",
    id: 6,
  },
]


export const roles = {
  CLUB: 3,
  VENUE: 5,
  PLAYER: 2,
  CREW: 4,
};

export const token = secureLocalStorage.getItem(
  process.env.REACT_APP_TOKEN_STORAGE_KEY
);

export const fcmToken = secureLocalStorage.getItem(
  process.env.REACT_APP_FCM_TOKEN_KEY
)
  ? secureLocalStorage.getItem(process.env.REACT_APP_FCM_TOKEN_KEY)
  : Cookies.get(process.env.REACT_APP_FCM_TOKEN_KEY);

export const userData = secureLocalStorage.getItem(
  process.env.REACT_APP_USER_STORAGE_KEY
);

export const USERS_LIST = secureLocalStorage.getItem(
  process.env.REACT_APP_USERS_LIST_KEY
);

export const APP_CONSTANT = {
  PRIVACY_POLICY_URL: "https://playmatez.io/privacy-policy",
  HELP_URL: "https://playmatez.io/support-hub",
};

export const VENUE_TYPE = {
  PRIVATE: 1,
  PUBLIC: 3,
  NORMAL: 2,
};

export const PRIMARY_TYPE = {
  CLUB: "club",
  ACADEMY: "academy",
};

export const purchaseDetail = [
  {
    id: 1,
    user: {
      name: "Amit Sharma",
    },
    dateOfpurchaseDetail: "2025-01-02",
    venue: "Royal Palace",
    amountPaid: 233,
    sportName: "Football",
    refrenceId: "FOT1234567890",
    location: "Mumbai, Maharashtra, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 2,
    user: {
      name: "Neha Verma",
      image: "profile2",
    },
    dateOfpurchaseDetail: "2025-01-03",
    venue: "Sunset Banquet",
    amountPaid: 450,
    sportName: "Tennis",
    refrenceId: "TNS1234567891",
    location: "Delhi, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 3,
    user: {
      name: "Rahul Mehta",
      image: "profile5",
    },
    dateOfpurchaseDetail: "2025-01-04",
    venue: "Green Garden",
    amountPaid: 300,
    sportName: "Badminton",
    refrenceId: "BDM1234567892",
    location: "Bangalore, Karnataka, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 4,
    user: {
      name: "Priya Singh",
      image: "profile1",
    },
    dateOfpurchaseDetail: "2025-01-05",
    venue: "Crystal Hall",
    amountPaid: 500,
    sportName: "Basketball",
    refrenceId: "BSK1234567893",
    location: "Kolkata, West Bengal, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 5,
    user: {
      name: "Vikas Kumar",
      image: "profile5",
    },
    dateOfpurchaseDetail: "2025-01-06",
    venue: "Ocean View",
    amountPaid: 650,
    sportName: "Cricket",
    refrenceId: "CRT1234567894",
    location: "Chennai, Tamil Nadu, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 6,
    user: {
      name: "Anjali Gupta",
      image: "profile3",
    },
    dateOfpurchaseDetail: "2025-01-07",
    venue: "Lotus Banquet",
    amountPaid: 280,
    sportName: "Hockey",
    refrenceId: "HKY1234567895",
    location: "Pune, Maharashtra, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 7,
    user: {
      name: "Rohit Jain",
      image: "profile5",
    },
    dateOfpurchaseDetail: "2025-01-08",
    venue: "Silver Star Hall",
    amountPaid: 420,
    sportName: "Football",
    refrenceId: "FOT1234567896",
    location: "Hyderabad, Telangana, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 8,
    user: {
      name: "Sneha Kapoor",
      image: "profile4",
    },
    dateOfpurchaseDetail: "2025-01-09",
    venue: "Pearl Palace",
    amountPaid: 390,
    sportName: "Volleyball",
    refrenceId: "VBL1234567897",
    location: "Ahmedabad, Gujarat, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 9,
    user: {
      name: "Kunal Shah",
      image: "profile5",
    },
    dateOfpurchaseDetail: "2025-01-10",
    venue: "Golden Crown",
    amountPaid: 550,
    sportName: "Cricket",
    refrenceId: "CRT1234567898",
    location: "Surat, Gujarat, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 10,
    user: {
      name: "Pooja Malhotra",
      image: "profile4",
    },
    dateOfpurchaseDetail: "2025-01-11",
    venue: "Emerald Hall",
    amountPaid: 470,
    sportName: "Tennis",
    refrenceId: "TNS1234567899",
    location: "Jaipur, Rajasthan, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
];

export const TYPES = {
  VENUE_DELETE_TYPE: 13,
  EVENT_DELETE_TYPE: 7,
  SERVICE_DELETE_TYPE: 2,
  JOIN_DELETE_TYPE: 5,
};

export const sportOptions = [
  { id: 1, name: "Cricket" },
  { id: 2, name: "Football" },
  { id: 3, name: "Tennis" },
  { id: 4, name: "Basketball" },
];

export const gameTypeOption = [
  { id: "indoor", name: "Indoor" },
  { id: "outdoor", name: "Outdoor" },
  { id: "hybrid", name: "Hybrid" },
  { id: "multiSportComplex", name: "Multi-sport Complex" },
];

export const designationOption = [
  { id: "Owner", name: "Owner" },
  { id: "Admin", name: "Admin" },
  { id: "Coach", name: "Coach" },
  { id: "Manager", name: "Manager" },
  { id: "Volunteer", name: "Volunteer" },
  { id: "Other", name: "Other" },
];

export const roleOption = [
  { id: 1, name: "Owner" },
  { id: 2, name: "Admin" },
  { id: 3, name: "Staff" },
  { id: 4, name: "Viewer" },
];

export const categoryOption = [
  { id: "Achievement", name: "🏆 Achievement" },
  { id: "Certification", name: "📜 Certification" },
  { id: "Award", name: "🏅 Award" },
  { id: "Qualification", name: "🎓 Qualification" },
  { id: "Milestone", name: "🎯 Milestone" },
];

export const levelOption = [
  { id: "Local", name: "Local" },
  { id: "State/Regional", name: "State/Regional" },
  { id: "National", name: "National" },
  { id: "International", name: "International" },
];

export const violationOption = ["Scam", "Harassment", "Abuse", "Abuse"];

export const USER_TYPE = {
  2: "Player",
  5: "Venue",
  3: "Club",
  4: "Crew",
};

export const MESSAGE_TYPES = {
  TEXT: "text",
  LOCATION: "location",
  IMAGE: "image",
  SYSTEM: "system",
};

export const CHAT_TYPES = {
  CARDS: "cards",
  CONNECTIONS: "connections",
  GROUPS: "groups",
  MARKETPLACE: "marketplace",
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const accessibility = [
  "Wheelchair Friendly",
  "Vision Impaired",
  "Deaf Friendly",
  "Intellectual Disabilities",
  "All Abilities",
];

export const no_player = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
];

export const ageGroup = [
  "Children under the age of 6",
  "Ages 7-12",
  "Ages 13-18",
  "Ages 19 and above",
  "Others",
];

export const CARD_BRAND_LABELS = {
  visa: "Visa",
  mastercard: "Mastercard",
  american_express: "American Express",
  amex: "American Express",
  discover: "Discover",
  diners_club: "Diners Club",
  jcb: "JCB",
  unionpay: "UnionPay",
  cartesian: "Cartesian",
  elo: "Elo",
  hipercard: "Hipercard",
  mir: "MIR",
  unknown: "Card",
};

export const venueSearch = [
  {
    venueImg: "https://picsum.photos/300/200?random=1",
    name: "Royal Palace Banquet",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=2",
    name: "Sunset Garden Venue",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=3",
    name: "Grand Orchid Hall",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=4",
    name: "Lakeside Convention Center",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=5",
    name: "Emerald Ballroom",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=6",
    name: "Silver Oak Resort",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=7",
    name: "Crystal Crown Venue",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=8",
    name: "The Heritage Courtyard",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=9",
    name: "Skyline Rooftop Lounge",
  },
];

// crewData.js
export const crewCategories = [
  {
    title: "Coaching & Training",
    options: [
      "Head Coach",
      "Assistant Coach",
      "Skill Coach (Batting / Bowling / Fielding / Goalkeeping etc.)",
      "Fitness Trainer",
      "Strength & Conditioning Coach",
      "Sports Nutritionist",
      "Sports Psychologist",
      "Performance Analyst",
    ],
  },
  {
    title: "Umpiring & Scoring",
    options: [
      "Umpire",
      "Referee",
      "Match Official",
      "Scorer / Statistician",
      "Match Recorder",
      "Video Analyst",
    ],
  },
  {
    title: "Sports Medicine & Recovery",
    options: [
      "Physiotherapist",
      "Sports Chiropractor",
      "Sports Doctor",
      "Athletic Trainer",
      "Recovery Specialist",
      "Masseur/Therapist",
    ],
  },
  {
    title: "Media & Photography",
    options: [
      "Photographer",
      "Videographer",
      "Drone Operator",
      "Live Stream Technician",
      "Commentary Team Member",
      "Socail Media / PR Crew",
    ],
  },
  {
    title: "Event & Operations",
    options: [
      "Event Manager",
      "Tournament Coordinator",
      "Ground Staff / pitch Curator",
      "Equipment Manager",
      "Logistics Assistant",
      "Volunteer / Support Crew",
    ],
  },
  {
    title: "Specialist Support",
    options: [
      "Data Analyst",
      "Biomechanics Expert",
      "Talent Scout",
      "Technical Consultant",
      "Sports Mentor",
    ],
  },
];

export const soughtOption = ["coach", "Referee", "Umpire", "Physio", "Other"];
export const PURCHASE_TYPE = {
  1: "Market Place",
  2: "Venue Booked",
  3: "Event Booked",
};
export const CARD_TYPE = {
  event: "Event Card",
  PSZ: "Service",
  PVZ: "Venue",
  PCZ: "Join",
  PGZ: "Game-On",
};
export const SEND_CARD_TYPE = {
  PSZ: "service",
  PVZ: "venue",
  PCZ: "join",
  PGZ: "gameOn",
};


export const CARDS_ENUMS = {
  GAME: "PGZ",
  SERVICE: "PSZ",
  JOIN: "PCZ",
  VENUE: "PVZ",
  LISTING: "listing",
  EVENT: "event",
};
export const CARDS_NAVIGATION_ENUMS = {
  event: "event",
  PSZ: "service",
  PVZ: "venue",
  PCZ: "join",
  PGZ: "game",
};

export const DELETE_CARDS_ENUMS = {
  event: 7,
  PSZ: 2,
  PVZ: 13,
  PCZ: 5,
  PGZ: 1,
};

export const NotificationType = {
  CHAT: 1,
  ACCEPT_PLAYER_GAME_ON_CARD_REQUEST: 2,
  ACCEPT_PLAYER_VENUE_CARD_REQUEST: 3,
  ACCEPT_PLAYER_CLUB_CARD_REQUEST: 4,
  SEND_PLAYER_GAME_ON_CARD_REQUEST_NOTIFICATION: 5,
  SEND_PLAYER_CLUB_GAME_ON_CARD_REQUEST_NOTIFICATION: 6,
  SEND_PLAYER_CREW_EVENT_REQUEST_NOTIFICATION: 7,
  SEND_PLAYER_VENUE_EVENT_REQUEST_NOTIFICATION: 8,
  ACCEPT_PLAYER_SERVICE_CARD_REQUEST: 9,
  SEND_CONNECTION_REQUEST_NOTIFICATION: 10,
  SEND_NOTIFICATION_ON_REELS_NOTIFICATION: 11,
  REJECT_CONNECTION_REQUEST: 12,
  PLAYER_REJECT_GAME_ON_REQUEST: 13,
  PLAYER_REJECT_VENUE_CARD_REQUEST: 14,
  PLAYER_REJECT_JOIN_CARD_REQUEST: 15,
  PLAYER_REJECT_SERVICE_CARD_REQUEST: 16,
  SELECT_CREW_OR_ASSOCIAN: 17,
  SELECT_CLUB_OR_ACADEMY: 18,
  SELECT_VENUE_INTEREST: 19,
  SEND_CLUB_PLAYER_JOIN_CARD_REQUEST_NOTIFICATION: 20,
  SEND_CLUB_TO_CLUB_JOIN_CARD_REQUEST_NOTIFICATION: 21,
  SEND_CLUB_CREW_EVENT_REQUEST_NOTIFICATION: 22,
  SEND_CLUB_VENUE_EVENT_REQUEST_NOTIFICATION: 23,
  SEND_CREW_PLAYER_SERVICE_CARD_REQUEST_NOTIFICATION: 24,
  SEND_CREW_CLUB_SERVICE_CARD_REQUEST_NOTIFICATION: 25,
  SEND_CREW_VENUE_SERVICE_CARD_REQUEST_NOTIFICATION: 26,
  SEND_VENUE_PLAYER_VENUE_CARD_REQUEST_NOTIFICATION: 27,
  SEND_VENUE_CLUB_VENUE_CARD_REQUEST_NOTIFICATION: 28,
  SEND_VENUE_CREW_EVENT_REQUEST_NOTIFICATION: 29,
  CLUB_ACCEPT_GAME_ON_CARD_REQUEST: 30,
  CLUB_ACCEPT_PLAYER_SERVICE_CARD_REQUEST: 31,
  CLUB_ACCEPT_CLUB_JOIN_CARD_REQUEST: 32,
  CLUB_ACCEPT_VENUE_CARD_REQUEST: 33,
  CREW_ACCEPT_PLAYER_EVENT_REQUEST: 34,
  CREW_ACCEPT_CLUB_EVENT_REQUEST: 35,
  CREW_ACCEPT_VENUE_EVENT_REQUEST: 36,
  VENUE_ACCEPT_PLAYER_EVENT_REQUEST: 37,
  VENUE_ACCEPT_CLUB_EVENT_REQUEST: 38,
  VENUE_ACCEPT_SERVICE_CARD_REQUEST: 39,
  CLUB_REJECT_GAME_ON_CARD_REQUEST: 40,
  CLUB_REJECT_SERVICE_CARD_REQUEST: 41,
  CLUB_REJECT_CLUB_TO_CLUB_JOIN_REQUEST: 42,
  CLUB_REJECT_VENUE_CARD_REQUEST: 43,
  CREW_REJECT_PLAYER_EVENT_REQUEST: 44,
  CREW_REJECT_CLUB_EVENT_REQUEST: 45,
  CREW_REJECT_VENUE_EVENT_REQUEST: 46,
  VENUE_REJECT_PLAYER_EVENT_REQUEST: 47,
  VENUE_REJECT_CLUB_EVENT_REQUEST: 48,
  VENUE_REJECT_SERVICE_CARD_REQUEST: 49,
  SEND_PLAYER_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION: 50,
  SEND_CLUB_TO_CLUB_CONNECTION_REQUEST_NOTIFICATION: 51,
  SEND_CLUB_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION: 52,
  SEND_CLUB_TO_CREW_CONNECTION_REQUEST_NOTIFICATION: 53,
  SEND_CLUB_TO_VENUE_CONNECTION_REQUEST_NOTIFICATION: 54,
  SEND_CREW_TO_CLUB_CONNECTION_REQUEST_NOTIFICATION: 55,
  SEND_CREW_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION: 56,
  SEND_CREW_TO_CREW_CONNECTION_REQUEST_NOTIFICATION: 57,
  SEND_CREW_TO_VENUE_CONNECTION_REQUEST_NOTIFICATION: 58,
  SEND_VENUE_TO_CLUB_CONNECTION_REQUEST_NOTIFICATION: 59,
  SEND_VENUE_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION: 60,
  SEND_VENUE_TO_CREW_CONNECTION_REQUEST_NOTIFICATION: 61,
  SEND_VENUE_TO_VENUE_CONNECTION_REQUEST_NOTIFICATION: 62,
  PLAYER_ACCEPT_PLAYER_CONNECTION_REQUEST: 63,
  PLAYER_ACCEPT_CLUB_CONNECTION_REQUEST: 64,
  PLAYER_ACCEPT_CREW_CONNECTION_REQUEST: 65,
  PLAYER_ACCEPT_VENUE_CONNECTION_REQUEST: 66,
  CLUB_ACCEPT_CLUB_CONNECTION_REQUEST: 67,
  CLUB_ACCEPT_CREW_CONNECTION_REQUEST: 68,
  CLUB_ACCEPT_VENUE_CONNECTION_REQUEST: 69,
  CREW_ACCEPT_CLUB_CONNECTION_REQUEST: 70,
  CREW_ACCEPT_CREW_CONNECTION_REQUEST: 71,
  CREW_ACCEPT_VENUE_CONNECTION_REQUEST: 72,
  VENUE_ACCEPT_CLUB_CONNECTION_REQUEST: 73,
  VENUE_ACCEPT_CREW_CONNECTION_REQUEST: 74,
  VENUE_ACCEPT_VENUE_CONNECTION_REQUEST: 75,
  USER_FOLLOW_OTHER_USERS: 76,
  CREATE_SCORE_CARD: 77,
  // SEND_PLAYER_TO_CLUB_CONNECTION_REQUEST: 79,
  VENUE_RATING_NOTIFICATION_TO_USER: 103,
  EXPIRED_OR_PAID: 121,
  CLUB_MEMBER_INVITE_REQUEST: 123,
  CLUB_MEMBER_INVITE_ACCEPTED: 124,
  CLUB_MEMBER_INVITE_REJECTED: 125,
};

const viewProfileNotificationTypes = [
  NotificationType.ACCEPT_PLAYER_GAME_ON_CARD_REQUEST,
  NotificationType.ACCEPT_PLAYER_CLUB_CARD_REQUEST,
  NotificationType.ACCEPT_PLAYER_SERVICE_CARD_REQUEST,
  NotificationType.ACCEPT_PLAYER_VENUE_CARD_REQUEST,
  NotificationType.CLUB_ACCEPT_PLAYER_SERVICE_CARD_REQUEST,
  NotificationType.VENUE_ACCEPT_PLAYER_EVENT_REQUEST,
  NotificationType.PLAYER_ACCEPT_PLAYER_CONNECTION_REQUEST,
  NotificationType.PLAYER_ACCEPT_CLUB_CONNECTION_REQUEST,
  NotificationType.PLAYER_ACCEPT_CREW_CONNECTION_REQUEST,
  NotificationType.PLAYER_ACCEPT_VENUE_CONNECTION_REQUEST,
  NotificationType.CLUB_ACCEPT_CLUB_CONNECTION_REQUEST,
  NotificationType.CLUB_ACCEPT_CREW_CONNECTION_REQUEST,
  NotificationType.CLUB_ACCEPT_VENUE_CONNECTION_REQUEST,
  NotificationType.CREW_ACCEPT_CLUB_CONNECTION_REQUEST,
  NotificationType.CREW_ACCEPT_CREW_CONNECTION_REQUEST,
  NotificationType.CREW_ACCEPT_VENUE_CONNECTION_REQUEST,
  NotificationType.VENUE_ACCEPT_CLUB_CONNECTION_REQUEST,
  NotificationType.VENUE_ACCEPT_CREW_CONNECTION_REQUEST,
  NotificationType.VENUE_ACCEPT_VENUE_CONNECTION_REQUEST,
  NotificationType.USER_FOLLOW_OTHER_USERS,
  NotificationType.CLUB_ACCEPT_GAME_ON_CARD_REQUEST,
  NotificationType.CLUB_ACCEPT_PLAYER_SERVICE_CARD_REQUEST,
  NotificationType.CLUB_ACCEPT_CLUB_JOIN_CARD_REQUEST,
  NotificationType.CLUB_ACCEPT_VENUE_CARD_REQUEST,
  NotificationType.CREW_ACCEPT_PLAYER_EVENT_REQUEST,
  NotificationType.CREW_ACCEPT_CLUB_EVENT_REQUEST,
  NotificationType.CREW_ACCEPT_VENUE_EVENT_REQUEST,
  NotificationType.VENUE_ACCEPT_PLAYER_EVENT_REQUEST,
  NotificationType.VENUE_ACCEPT_CLUB_EVENT_REQUEST,
  NotificationType.VENUE_ACCEPT_SERVICE_CARD_REQUEST,
  NotificationType.CLUB_REJECT_GAME_ON_CARD_REQUEST,
  NotificationType.CLUB_REJECT_SERVICE_CARD_REQUEST,
  NotificationType.CLUB_REJECT_CLUB_TO_CLUB_JOIN_REQUEST,
  NotificationType.CLUB_REJECT_VENUE_CARD_REQUEST,
  NotificationType.CREW_REJECT_PLAYER_EVENT_REQUEST,
  NotificationType.CREW_REJECT_CLUB_EVENT_REQUEST,
  NotificationType.CREW_REJECT_VENUE_EVENT_REQUEST,
  NotificationType.VENUE_REJECT_PLAYER_EVENT_REQUEST,
  NotificationType.VENUE_REJECT_CLUB_EVENT_REQUEST,
  NotificationType.VENUE_REJECT_SERVICE_CARD_REQUEST,
  NotificationType.REJECT_CONNECTION_REQUEST,
  NotificationType.PLAYER_REJECT_GAME_ON_REQUEST,
  NotificationType.PLAYER_REJECT_VENUE_CARD_REQUEST,
  NotificationType.PLAYER_REJECT_JOIN_CARD_REQUEST,
  NotificationType.PLAYER_REJECT_SERVICE_CARD_REQUEST,
  NotificationType.SELECT_CREW_OR_ASSOCIAN,
  NotificationType.SELECT_CLUB_OR_ACADEMY,
  NotificationType.SELECT_VENUE_INTEREST,
  NotificationType.SEND_PLAYER_GAME_ON_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_PLAYER_CLUB_GAME_ON_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_PLAYER_CREW_EVENT_REQUEST_NOTIFICATION,
  NotificationType.SEND_PLAYER_VENUE_EVENT_REQUEST_NOTIFICATION,
  NotificationType.SEND_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_NOTIFICATION_ON_REELS_NOTIFICATION,
  NotificationType.SEND_CLUB_PLAYER_JOIN_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_TO_CLUB_JOIN_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_CREW_EVENT_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_VENUE_EVENT_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_PLAYER_SERVICE_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_CLUB_SERVICE_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_VENUE_SERVICE_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_VENUE_PLAYER_VENUE_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_VENUE_CREW_EVENT_REQUEST_NOTIFICATION,
  NotificationType.SEND_PLAYER_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_TO_CLUB_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_TO_CREW_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_TO_VENUE_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_TO_CLUB_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_TO_CREW_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_TO_VENUE_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_VENUE_TO_CLUB_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_VENUE_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_VENUE_TO_CREW_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_VENUE_TO_VENUE_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_PLAYER_TO_CLUB_CONNECTION_REQUEST,
];

export function isViewProfile(notificationType) {
  if (notificationType == null) return false;
  return viewProfileNotificationTypes.includes(notificationType);
}

export const REQUEST_STATUS = {
  ACCEPT_REQUEST: 1,
  REJECT_REQUEST: 2,
  HIDE_BTN_REQUEST: 4,
};

export const CONNECTIONS_STATUS = {
  PENDING: 0,
  CONNECTED: 1,
  REJECTED: 3,
};


export const AGE_GROUP = [
  'U10',
  'U12',
  'U14',
  'U16',
  'U18',
  'Adult',
  'Senior',
  'All Ages',
];
